import React from "react";

import { Checkbox } from "../../checkbox";
import { Props } from "./types";
import styles from "./styles.scss";

function Tag({ tag, isSelected, select, unSelect }: Props) {
  return (
    <div className={styles.tag} onClick={!isSelected ? select : unSelect}>
      <Checkbox isChecked={isSelected} />
      <p className={styles.name}>{tag.name}</p>
    </div>
  );
}

export { Tag };
